// Node
const $ = require('jquery');

class SearchForm {
  constructor (formId) {
    this.$form = $(`form#${formId}`);
  }

  refresh () {
    this.$form.eq(0).trigger('submit');
  }

  reset () {
    this.datePicker.reset();
    this.guestsWidget.reset();

    let $decease_select = $("#camp_treatment_profiles");
    if ($decease_select.length !== 0) {
      $decease_select.val(null);
    }

    this.refresh();
  }

  static async getSearchData() {
    if (window.__searchDataFetch) {
      return window.__searchDataFetch;
    }

    try {
      window.__searchDataFetch = fetch(`/helpers/search_data?url=${encodeURIComponent(location.href)}`)
          .then(response => response.json());

      const data = await window.__searchDataFetch;
      return data;
    } finally {
      window.__searchDataFetch = null;
    }
  }

  _init () {

  }
}

if (!window.__searchDataFetch) {
  window.__searchDataFetch = null;
}

export default SearchForm;
